/* Control™ — efectos del tema: aparición, carruseles, paralaje. Sin dependencias. */
(function () {
  if (window.__ctlInit) return;
  window.__ctlInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll */
  /* Se mide la posición en cada scroll (sin depender de IntersectionObserver, que se pausa
     en pestañas en segundo plano). Dentro de una línea recortada se mide la línea. */
  var pending = [];
  function checkReveal() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    pending = pending.filter(function (el) {
      if (!el.isConnected) return false;
      var r = (el.closest('.ctl-line') || el).getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0) { el.classList.add('is-in'); return false; }
      return true;
    });
  }
  function initReveal(root) {
    root.querySelectorAll('[data-ctl-reveal]:not(.is-in)').forEach(function (el) {
      if (reduce) { el.classList.add('is-in'); return; }
      if (pending.indexOf(el) === -1) pending.push(el);
    });
    checkReveal();
  }
  var lastCheck = 0;
  window.addEventListener('scroll', function () {
    var now = Date.now();
    if (now - lastCheck > 60) { lastCheck = now; checkReveal(); }
    else setTimeout(checkReveal, 80);
  }, { passive: true });
  window.addEventListener('resize', checkReveal);
  window.addEventListener('load', checkReveal);

  /* Carruseles: flechas que avanzan exactamente una tarjeta (con snap) */
  function initCarousels(root) {
    root.querySelectorAll('[data-ctl-carousel]').forEach(function (wrap) {
      if (wrap.__ctl) return; wrap.__ctl = true;
      var track = wrap.querySelector('[data-ctl-track]');
      var prev = wrap.querySelector('[data-ctl-prev]');
      var next = wrap.querySelector('[data-ctl-next]');
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Paralaje suave: el elemento es más alto que su marco y se desplaza con el scroll */
  var pEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-ctl-parallax]').forEach(function (el) {
      if (pEls.indexOf(el) === -1) pEls.push(el);
    });
    tick();
  }
  var ticking = false;
  function tick() {
    ticking = false;
    var vh = window.innerHeight;
    pEls.forEach(function (el) {
      if (!el.isConnected) return;
      var frame = el.parentElement.getBoundingClientRect();
      if (frame.bottom < -200 || frame.top > vh + 200) return;
      var speed = parseFloat(el.getAttribute('data-ctl-parallax')) || 0.2;
      var center = frame.top + frame.height / 2 - vh / 2;
      var extra = el.offsetHeight - frame.height;
      var y = Math.max(-extra / 2, Math.min(extra / 2, -center * speed));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking && pEls.length) { ticking = true; window.requestAnimationFrame(tick); }
  }, { passive: true });
  window.addEventListener('resize', tick);

  /* Selector de idioma propio: envía el formulario al elegir */
  function initLang(root) {
    root.querySelectorAll('[data-ctl-lang] button[name="language_code"]').forEach(function (b) {
      if (b.__ctl) return; b.__ctl = true;
      b.addEventListener('click', function () {
        var input = b.form.querySelector('input[name="language_code"]');
        if (input) input.value = b.value;
      });
    });
  }

  /* Nombres de opción que el proveedor dejó en inglés: se muestran en español en la tienda en español */
  var OPC = { size: 'Talla', colour: 'Color' };
  function traducirOpciones(root) {
    if ((document.documentElement.lang || '').slice(0, 2) !== 'es') return;
    root.querySelectorAll('.product-form__input .form__label, .product-option dt, .cart-item__details dt').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType !== 3) return;
        var t = n.textContent.trim().replace(/:$/, '').toLowerCase();
        if (OPC[t]) n.textContent = n.textContent.replace(/size|colour/i, OPC[t]);
      });
    });
  }
  /* Descripción del producto: cada apartado con título (h3) se vuelve desplegable; la intro queda visible */
  function descripcionColapsable(root) {
    root.querySelectorAll('.product__description:not([data-ctl-col])').forEach(function (d) {
      var h3s = d.querySelectorAll(':scope > h3');
      if (!h3s.length) return;
      d.setAttribute('data-ctl-col', '');
      h3s.forEach(function (h) {
        var det = document.createElement('details');
        det.className = 'ctl-det';
        var sum = document.createElement('summary');
        sum.innerHTML = '<span>' + h.textContent + '</span><span class="ctl-det__i" aria-hidden="true"></span>';
        det.appendChild(sum);
        var cuerpo = document.createElement('div');
        cuerpo.className = 'ctl-det__cuerpo';
        var n = h.nextElementSibling;
        while (n && n.tagName !== 'H3') { var sig = n.nextElementSibling; cuerpo.appendChild(n); n = sig; }
        det.appendChild(cuerpo);
        h.replaceWith(det);
      });
    });
  }
  /* Nombre del color elegido junto a "Color" en la ficha */
  function colorElegido(root) {
    root.querySelectorAll('.ctl-colores').forEach(function (fs) {
      var sel = fs.querySelector('input:checked');
      var out = fs.querySelector('.ctl-colores__sel');
      if (sel && out && out.textContent !== sel.value) out.textContent = sel.value;
    });
  }
  var mo = new MutationObserver(function () { traducirOpciones(document); descripcionColapsable(document); colorElegido(document); });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.ctl-colores')) colorElegido(document); });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  /* Agregado rápido: elige opciones → variante → añade a la bolsa y abre el cajón del carrito */
  function initQuick(root) {
    root.querySelectorAll('[data-ctl-quick]').forEach(function (card) {
      if (card.__ctl) return; card.__ctl = true;
      var form = card.querySelector('[data-ctl-quick-form]');
      if (!form) return;
      var data = card.querySelector('[data-ctl-variants]');
      var variants = data ? JSON.parse(data.textContent) : [];
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-ctl-quick-btn]');
      var txt = btn.querySelector('[data-ctl-txt]');
      var base = txt.textContent;
      var msg = form.querySelector('[data-ctl-quick-msg]');
      var selects = form.querySelectorAll('[data-ctl-opt]');
      function actual() {
        var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
        return variants.find(function (v) { return vals.every(function (val, i) { return v.options[i] === val; }); });
      }
      var img = card.querySelector('.ctl-quick__img');
      var img2 = card.querySelector('.ctl-quick__img--2');
      var fotosEl = card.querySelector('[data-ctl-fotos]');
      var fotos = {};
      try { fotos = fotosEl ? JSON.parse(fotosEl.textContent) : {}; } catch (err) { fotos = {}; }
      var colorIdx = parseInt(card.getAttribute('data-color-idx'), 10);
      function ancho(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700'; }
      function poner(el, src) { if (el && src && el.getAttribute('src') !== src) { el.removeAttribute('srcset'); el.setAttribute('src', src); } }
      var primera = true;
      function sync() {
        var v = actual();
        if (v) idInput.value = v.id;
        /* al empezar se respeta la foto elegida en el editor; al cambiar de color se busca su espalda */
        if (v && !primera) {
          var color = colorIdx > -1 ? String(v.options[colorIdx]).toLowerCase() : '';
          var frente = v.featured_image ? ancho(v.featured_image.src) : null;
          if (fotos[color]) { poner(img, fotos[color]); poner(img2, frente); }
          else if (frente) { poner(img, frente); }
        }
        primera = false;
        var ok = v && v.available;
        btn.disabled = !ok;
        txt.textContent = ok ? base : (window.ctlTextos && window.ctlTextos.agotado) || 'Agotado';
      }
      selects.forEach(function (s) { s.addEventListener('change', sync); });
      var nombreColor = card.querySelector('[data-ctl-qcolor]');
      card.querySelectorAll('[data-ctl-qsw]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var sel = form.querySelector('[data-ctl-opt="' + colorIdx + '"]');
          if (!sel) return;
          sel.value = b.getAttribute('data-ctl-qsw');
          card.querySelectorAll('[data-ctl-qsw]').forEach(function (o) { var on = o === b; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
          if (nombreColor) nombreColor.textContent = sel.value;
          sel.dispatchEvent(new Event('change'));
        });
      });
      sync();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true; card.classList.add('is-loading'); msg.textContent = '';
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
        if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { msg.textContent = res.description || res.message || 'Error'; return; }
          card.classList.add('is-added');
          txt.textContent = (window.ctlTextos && window.ctlTextos.agregado) || '✓';
          setTimeout(function () { card.classList.remove('is-added'); txt.textContent = base; }, 1800);
          if (drawer && typeof drawer.renderContents === 'function') {
            var item = res.items && res.items[0] ? res.items[0] : {};
            drawer.renderContents({ id: item.variant_id || item.id, sections: res.sections });
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else {
            document.dispatchEvent(new CustomEvent('ctl:cart-added'));
          }
        }).catch(function () { msg.textContent = 'Error'; })
          .finally(function () { card.classList.remove('is-loading'); sync(); });
      });
    });
  }

  /* ---------- Tarjetas: puntitos de color + widget de agregado rápido (estilo widget iOS) ---------- */
  var T = function (k, d) { return (window.ctlTextos && window.ctlTextos[k]) || d; };
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* mismo formato que la tienda: $ 1,527.78 */
  function dinero(cents) {
    return '$ ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function hexColor(n) {
    var m = { 'black': '#141414', 'white': '#FFFFFF', 'charcoal gray': '#4B4B4E', 'dark gray': '#4B4B4E', 'flower gray': '#C9CBCE', 'gray': '#B9BBBE', 'navy blue': '#1F2A44', 'pink': '#F2BCC3', 'red': '#9E2430', 'ash purple': '#BDAEB8', 'gray green': '#A7B7A2', 'army green': '#5A5D3E', 'dark brown': '#4A3226', 'green': '#A6DCC8', 'oat gray': '#D3CCBF', 'apricot': '#F1E6CF' };
    return m[String(n).toLowerCase().trim()] || '#D9D6CF';
  }
  function img900(src) { if (!src) return ''; src = src.replace(/^\/\//, 'https://').replace(/^http:/, 'https:'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900'; }

  function initCards(root) {
    root.querySelectorAll('[data-ctl-card]').forEach(function (card) {
      if (card.__ctl) return; card.__ctl = true;
    });
  }
  /* círculos de color: tarjetas propias y tarjetas de colección/búsqueda (delegado, sobrevive a filtros) */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-ctl-sw]');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    var card = sw.closest('[data-ctl-card], .card-wrapper');
    if (!card) return;
    card.querySelectorAll('[data-ctl-sw]').forEach(function (o) { o.classList.remove('is-active'); });
    sw.classList.add('is-active');
    var img = card.querySelector('.ctl-card__img, .card__media img');
    var src = sw.getAttribute('data-img');
    if (src && img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.setAttribute('src', src); card.classList.add('is-swatched'); }
  }, true);
  /* "+" delegado: sirve también para contenido que se vuelve a pintar (carrito lateral) */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-ctl-plus]');
    if (!plus) return;
    var card = plus.closest('[data-handle]');
    if (!card) return;
    e.preventDefault();
    var activo = card.querySelector('[data-ctl-sw].is-active');
    abrirWidget(card.getAttribute('data-handle'), activo ? activo.getAttribute('title') : null, plus);
  });

  var W = null, wDatos = null, wOrigen = null;
  function crearWidget() {
    W = document.createElement('div');
    W.className = 'ctl-qw';
    W.setAttribute('hidden', '');
    W.innerHTML =
      '<div class="ctl-qw__backdrop" data-qw-cerrar></div>' +
      '<div class="ctl-qw__card" role="dialog" aria-modal="true" aria-labelledby="CtlQwTitulo" tabindex="-1">' +
        '<span class="ctl-qw__grab" aria-hidden="true"></span>' +
        '<button type="button" class="ctl-qw__x" data-qw-cerrar aria-label="' + T('cerrar', 'Cerrar') + '"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
        '<div class="ctl-qw__top">' +
          '<div class="ctl-qw__foto"><img alt="" data-qw-img></div>' +
          '<div class="ctl-qw__head">' +
            '<p class="ctl-qw__marca">Control™</p>' +
            '<h2 class="ctl-qw__titulo" id="CtlQwTitulo" data-qw-titulo></h2>' +
            '<p class="ctl-qw__precio" data-qw-precio></p>' +
          '</div>' +
        '</div>' +
        '<div class="ctl-qw__opciones" data-qw-opciones></div>' +
        '<button type="button" class="ctl-qw__add" data-qw-add><span data-qw-add-txt></span><span class="ctl-qw__add-precio" data-qw-add-precio></span></button>' +
        '<a class="ctl-qw__ver" data-qw-ver href="#">' + T('verProducto', 'Ver producto') + ' ↗</a>' +
        '<p class="ctl-qw__msg" data-qw-msg aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(W);
    W.querySelectorAll('[data-qw-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarWidget); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && W && !W.hasAttribute('hidden')) cerrarWidget(); });
    W.querySelector('[data-qw-add]').addEventListener('click', agregarWidget);
  }
  function cerrarWidget() {
    if (!W) return;
    W.classList.remove('is-open');
    document.documentElement.classList.remove('ctl-qw-abierto');
    setTimeout(function () { W.setAttribute('hidden', ''); }, reduce ? 0 : 320);
    if (wOrigen) wOrigen.focus();
  }
  function varianteActual() {
    var sel = Array.prototype.map.call(W.querySelectorAll('[data-qw-grupo]'), function (g) {
      var a = g.querySelector('[aria-pressed="true"]'); return a ? a.getAttribute('data-valor') : null;
    });
    return wDatos.variants.find(function (v) { return sel.every(function (val, i) { return v.options[i] === val; }); });
  }
  function pintarEstado() {
    var v = varianteActual();
    var add = W.querySelector('[data-qw-add]');
    var txt = W.querySelector('[data-qw-add-txt]');
    var ok = v && v.available;
    add.disabled = !ok;
    txt.textContent = ok ? T('agregarBolsa', 'Agregar a la bolsa') : T('agotado', 'Agotado');
    W.querySelector('[data-qw-add-precio]').textContent = v ? dinero(v.price) : '';
    W.querySelector('[data-qw-precio]').textContent = v ? dinero(v.price) : '';
    if (v && v.featured_image) { var im = W.querySelector('[data-qw-img]'); im.src = img900(v.featured_image.src); }
    /* marca tallas agotadas para el color elegido */
    W.querySelectorAll('[data-qw-grupo]').forEach(function (g, gi) {
      g.querySelectorAll('[data-valor]').forEach(function (b) {
        var prueba = Array.prototype.map.call(W.querySelectorAll('[data-qw-grupo]'), function (gg, i) {
          if (i === gi) return b.getAttribute('data-valor');
          var a = gg.querySelector('[aria-pressed="true"]'); return a ? a.getAttribute('data-valor') : null;
        });
        var existe = wDatos.variants.some(function (vv) { return vv.available && prueba.every(function (val, i) { return vv.options[i] === val; }); });
        b.classList.toggle('is-agotado', !existe);
      });
    });
  }
  function abrirWidget(handle, colorInicial, origen) {
    if (!W) crearWidget();
    wOrigen = origen;
    W.classList.add('is-cargando');
    W.removeAttribute('hidden');
    document.documentElement.classList.add('ctl-qw-abierto');
    requestAnimationFrame(function () { requestAnimationFrame(function () { W.classList.add('is-open'); }); });
    W.querySelector('[data-qw-msg]').textContent = '';
    fetch(RAIZ + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      wDatos = p;
      W.querySelector('[data-qw-titulo]').textContent = p.title;
      W.querySelector('[data-qw-ver]').href = RAIZ + 'products/' + handle;
      W.querySelector('[data-qw-img]').src = img900(p.featured_image);
      var cont = W.querySelector('[data-qw-opciones]');
      cont.innerHTML = '';
      var inicial = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      (p.options || []).forEach(function (op, i) {
        var nombre = typeof op === 'string' ? op : op.name;
        var valores = typeof op === 'string' ? Array.from(new Set(p.variants.map(function (v) { return v.options[i]; }))) : op.values;
        if (valores.length === 1 && /title/i.test(nombre)) return;
        var esColor = /^colou?r$/i.test(nombre);
        var nombreVisible = esColor ? T('color', 'Color') : (/^size$/i.test(nombre) ? T('talla', 'Talla') : nombre);
        if (esColor && colorInicial) {
          var conColor = p.variants.find(function (v) { return v.options[i] === colorInicial && v.available; });
          if (conColor) inicial = conColor;
        }
        var g = document.createElement('div');
        g.className = 'ctl-qw__grupo' + (esColor ? ' is-color' : '');
        g.setAttribute('data-qw-grupo', i);
        var html = '<p class="ctl-qw__label">' + nombreVisible + ' <span data-qw-elegido></span></p><div class="ctl-qw__valores">';
        valores.forEach(function (val) {
          html += esColor
            ? '<button type="button" class="ctl-qw__sw" style="--c:' + hexColor(val) + '" data-valor="' + val.replace(/"/g, '&quot;') + '" aria-pressed="false" aria-label="' + val.replace(/"/g, '&quot;') + '" title="' + val.replace(/"/g, '&quot;') + '"></button>'
            : '<button type="button" class="ctl-qw__pill" data-valor="' + val.replace(/"/g, '&quot;') + '" aria-pressed="false">' + val + '</button>';
        });
        g.innerHTML = html + '</div>';
        cont.appendChild(g);
      });
      W.querySelectorAll('[data-qw-grupo]').forEach(function (g) {
        var i = +g.getAttribute('data-qw-grupo');
        g.querySelectorAll('[data-valor]').forEach(function (b) {
          if (b.getAttribute('data-valor') === inicial.options[i]) b.setAttribute('aria-pressed', 'true');
          b.addEventListener('click', function () {
            g.querySelectorAll('[data-valor]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            var e = g.querySelector('[data-qw-elegido]'); if (e) e.textContent = b.getAttribute('data-valor');
            pintarEstado();
          });
        });
        var el = g.querySelector('[data-qw-elegido]'); if (el) el.textContent = inicial.options[i];
      });
      pintarEstado();
      W.classList.remove('is-cargando');
      W.querySelector('.ctl-qw__card').focus();
    }).catch(function () { W.querySelector('[data-qw-msg]').textContent = 'Error'; W.classList.remove('is-cargando'); });
  }
  function agregarWidget() {
    var v = varianteActual(); if (!v || !v.available) return;
    var add = W.querySelector('[data-qw-add]');
    add.disabled = true; W.classList.add('is-agregando');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(RAIZ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { W.querySelector('[data-qw-msg]').textContent = res.description || res.message || 'Error'; return; }
        W.querySelector('[data-qw-add-txt]').textContent = T('agregado', 'Agregado ✓');
        W.classList.add('is-hecho');
        setTimeout(function () {
          cerrarWidget(); W.classList.remove('is-hecho');
          if (drawer && typeof drawer.renderContents === 'function') {
            var item = res.items && res.items[0] ? res.items[0] : {};
            drawer.renderContents({ id: item.variant_id || item.id, sections: res.sections });
            drawer.classList.remove('is-empty');
          }
        }, 650);
      }).catch(function () { W.querySelector('[data-qw-msg]').textContent = 'Error'; })
      .finally(function () { W.classList.remove('is-agregando'); add.disabled = false; });
  }

  /* ---------- Outfits: looks completos y combinador ---------- */
  function varPieza(pz) {
    var vs; try { vs = JSON.parse(pz.querySelector('[data-ctl-pz-v]').textContent); } catch (e) { return null; }
    var ci = +pz.getAttribute('data-ci'), si = +pz.getAttribute('data-si');
    var color = pz.getAttribute('data-color');
    var sel = pz.querySelector('[data-ctl-pz-talla]');
    var talla = sel ? sel.value : null;
    return vs.find(function (v) {
      return (ci < 0 || !color || v.options[ci] === color) && (si < 0 || !talla || v.options[si] === talla) && v.available;
    }) || null;
  }
  function recalcLook(box) {
    var piezas = box.querySelectorAll('[data-ctl-pz]');
    var total = 0, ok = piezas.length > 0;
    piezas.forEach(function (pz) {
      var v = varPieza(pz);
      pz.classList.toggle('is-agotado', !v);
      if (v) total += v.price; else ok = false;
    });
    var t = box.querySelector('[data-ctl-look-total]');
    if (t) t.textContent = dinero(total);
    var b = box.querySelector('[data-ctl-look-add]');
    if (b) b.disabled = !ok;
  }
  function agregarLook(box, btn) {
    var items = [];
    box.querySelectorAll('[data-ctl-pz]').forEach(function (pz) { var v = varPieza(pz); if (v) items.push({ id: v.id, quantity: 1 }); });
    if (!items.length) return;
    var txt = btn.querySelector('[data-ctl-txt]'); var base = txt.textContent;
    var msg = box.querySelector('[data-ctl-look-msg]'); if (msg) msg.textContent = '';
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(RAIZ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { if (msg) msg.textContent = res.description || res.message || 'Error'; return; }
        txt.textContent = T('agregado', 'Agregado ✓');
        setTimeout(function () { txt.textContent = base; }, 1800);
        if (drawer && typeof drawer.renderContents === 'function') {
          var item = res.items && res.items[0] ? res.items[0] : {};
          drawer.renderContents({ id: item.variant_id || item.id, sections: res.sections });
          drawer.classList.remove('is-empty');
        }
      }).catch(function () { if (msg) msg.textContent = 'Error'; })
      .finally(function () { btn.disabled = false; recalcLook(box); });
  }
  /* cambiar el color de una prenda dentro de un look / combinación */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ctl-pz-color]');
    if (!b) return;
    var pz = b.closest('[data-ctl-pz]'); if (!pz) return;
    var color = b.getAttribute('data-ctl-pz-color');
    pz.querySelectorAll('[data-ctl-pz-color]').forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
    pz.setAttribute('data-color', color);
    var txt = pz.querySelector('[data-ctl-pz-colortxt]'); if (txt) txt.textContent = color + ' · ';
    var vs; try { vs = JSON.parse(pz.querySelector('[data-ctl-pz-v]').textContent); } catch (err) { vs = []; }
    var ci = +pz.getAttribute('data-ci'), si = +pz.getAttribute('data-si');
    var conFoto = vs.find(function (v) { return v.options[ci] === color && v.featured_image; });
    var img = pz.querySelector('.ctl-pz__img img');
    if (conFoto && img) { img.removeAttribute('srcset'); img.src = img900(conFoto.featured_image.src); }
    var sel = pz.querySelector('[data-ctl-pz-talla]');
    if (sel && si > -1) {
      var primera = null;
      Array.prototype.forEach.call(sel.options, function (op) {
        var hay = vs.some(function (v) { return v.available && v.options[ci] === color && v.options[si] === op.value; });
        op.disabled = !hay; if (hay && !primera) primera = op.value;
      });
      if (sel.selectedOptions[0] && sel.selectedOptions[0].disabled && primera) sel.value = primera;
    }
    var box = pz.closest('[data-ctl-look], [data-ctl-combo]'); if (box) recalcLook(box);
  });

  function initOutfits(root) {
    root.querySelectorAll('[data-ctl-look], [data-ctl-combo]').forEach(function (box) {
      if (box.__ctl) return; box.__ctl = true;
      recalcLook(box);
      box.addEventListener('change', function (e) { if (e.target.matches('[data-ctl-pz-talla]')) recalcLook(box); });
      var btn = box.querySelector('[data-ctl-look-add]');
      if (btn) btn.addEventListener('click', function () { agregarLook(box, btn); });
    });
    root.querySelectorAll('[data-ctl-combo]').forEach(function (combo) {
      if (combo.__ctlCombo) return; combo.__ctlCombo = true;
      var lista = combo.querySelector('[data-ctl-combo-piezas]');
      var vacio = combo.querySelector('[data-ctl-combo-vacio]');
      combo.querySelectorAll('[data-ctl-fila]').forEach(function (fila) {
        var n = fila.getAttribute('data-ctl-fila');
        var nombre = fila.querySelector('[data-ctl-fila-nombre]');
        fila.querySelectorAll('[data-ctl-op]').forEach(function (op) {
          op.addEventListener('click', function () {
            fila.querySelectorAll('[data-ctl-op]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
            op.setAttribute('aria-checked', 'true');
            var h = op.getAttribute('data-ctl-op');
            nombre.textContent = h ? op.getAttribute('data-nombre') : '—';
            var viejo = lista.querySelector('[data-fila="' + n + '"]'); if (viejo) viejo.remove();
            if (h) {
              var tpl = fila.querySelector('template[data-handle="' + h + '"]');
              if (tpl) {
                var pz = tpl.content.firstElementChild.cloneNode(true);
                pz.setAttribute('data-fila', n);
                /* ordenar por fila */
                var despues = Array.prototype.find.call(lista.querySelectorAll('[data-fila]'), function (x) { return +x.getAttribute('data-fila') > +n; });
                lista.insertBefore(pz, despues || null);
              }
            }
            vacio.hidden = !!lista.querySelector('[data-ctl-pz]');
            recalcLook(combo);
          });
        });
      });
    });
  }

  function init(root) { initOutfits(root); initReveal(root); initCarousels(root); initParallax(root); initLang(root); traducirOpciones(root); initQuick(root); initCards(root); descripcionColapsable(root); colorElegido(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('[data-ctl-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();


/* Galería compacta: píldora de puntitos sobre la foto (móvil) */
(function initPuntosGaleria() {
  document.querySelectorAll('media-gallery').forEach(function (galeria) {
    var lista = galeria.querySelector('.product__media-list');
    var visor = galeria.querySelector('slider-component');
    if (!lista || !visor || visor.querySelector('.ctl-dots')) return;
    var pildora = document.createElement('div');
    pildora.className = 'ctl-dots';
    pildora.setAttribute('aria-hidden', 'true');
    var pista = document.createElement('div');
    pista.className = 'ctl-dots__track';
    var ventana = document.createElement('div');
    ventana.className = 'ctl-dots__ventana';
    ventana.appendChild(pista);
    pildora.appendChild(ventana);
    visor.appendChild(pildora);
    var fotos = [], actual = -1;

    function visibles() {
      return Array.prototype.filter.call(lista.querySelectorAll('.product__media-item'), function (li) { return li.offsetParent !== null && li.offsetWidth > 0; });
    }
    function construir() {
      fotos = visibles();
      pista.innerHTML = '';
      pildora.hidden = fotos.length < 2;
      fotos.forEach(function (li, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ctl-dots__dot'; b.tabIndex = -1;
        b.addEventListener('click', function () { lista.scrollTo({ left: li.offsetLeft - lista.offsetLeft, behavior: 'smooth' }); });
        pista.appendChild(b);
      });
      actual = -1; marcar();
    }
    function marcar() {
      if (!fotos.length) return;
      var x = lista.scrollLeft, mejor = 0, dist = Infinity;
      fotos.forEach(function (li, i) { var d = Math.abs(li.offsetLeft - lista.offsetLeft - x); if (d < dist) { dist = d; mejor = i; } });
      if (mejor === actual) return;
      actual = mejor;
      var puntos = pista.children;
      for (var i = 0; i < puntos.length; i++) puntos[i].classList.toggle('is-active', i === mejor);
      // con muchas fotos, la píldora se desplaza para que el punto activo quede a la vista
      var ancho = ventana.clientWidth, total = pista.scrollWidth;
      var activo = puntos[mejor], desplazar = 0;
      if (total > ancho && activo) desplazar = Math.min(Math.max(activo.offsetLeft + activo.offsetWidth / 2 - ancho / 2, 0), total - ancho);
      pildora.classList.toggle('is-desborde', total > ancho);
      pista.style.transform = 'translateX(' + (-desplazar) + 'px)';
    }
    var espera;
    lista.addEventListener('scroll', function () { cancelAnimationFrame(espera); espera = requestAnimationFrame(marcar); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(construir, 200); });
    // al cambiar de color Dawn reordena las fotos: se vuelve a contar
    new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(construir, 80); }).observe(lista, { childList: true });
    // al filtrar las fotos por color se vuelven a contar los puntitos
    document.addEventListener('ctl:fotos', function () { clearTimeout(espera); espera = setTimeout(construir, 30); });
    construir();
  });
})();

/* Ficha (celular): barra fija con foto, nombre, precio y "Agregar" cuando el botón principal ya no se ve */
(function initBarraCompra() {
  var principal = document.querySelector('.product-form__submit[name="add"]');
  var info = document.querySelector('.product__info-container');
  if (!principal || !info || document.querySelector('.ctl-barra-compra')) return;
  var titulo = info.querySelector('.product__title h1, .product__title h2');
  var foto = document.querySelector('.product__media-item img');
  var barra = document.createElement('div');
  barra.className = 'ctl-barra-compra';
  barra.setAttribute('aria-hidden', 'true');
  barra.innerHTML =
    '<span class="ctl-barra-compra__foto">' + (foto ? '<img alt="" src="' + (foto.currentSrc || foto.src) + '">' : '') + '</span>' +
    '<span class="ctl-barra-compra__info"><span class="ctl-barra-compra__nombre"></span><span class="ctl-barra-compra__precio"></span></span>' +
    '<button type="button" class="ctl-barra-compra__btn" tabindex="-1"></button>';
  document.body.appendChild(barra);
  var nombre = barra.querySelector('.ctl-barra-compra__nombre');
  var precio = barra.querySelector('.ctl-barra-compra__precio');
  var btn = barra.querySelector('.ctl-barra-compra__btn');
  nombre.textContent = titulo ? titulo.textContent.trim() : '';
  function copiar() {
    var p = info.querySelector('.price .price-item--sale, .price .price__regular .price-item--regular');
    precio.textContent = p ? p.textContent.trim() : '';
    var txt = principal.querySelector('span') || principal;
    btn.textContent = txt.textContent.trim();
    btn.disabled = principal.disabled;
  }
  function revisar() {
    var r = principal.getBoundingClientRect();
    var fuera = r.bottom < 0 || r.top > window.innerHeight;
    var abierto = document.querySelector('cart-drawer.active, .ctl-qw:not([hidden])');
    barra.classList.toggle('is-visible', fuera && !abierto && window.innerWidth < 750);
  }
  btn.addEventListener('click', function () { if (!principal.disabled) principal.click(); });
  new MutationObserver(copiar).observe(principal, { attributes: true, childList: true, subtree: true, characterData: true });
  var precioCaja = info.querySelector('.price');
  if (precioCaja) new MutationObserver(copiar).observe(precioCaja.parentElement, { childList: true, subtree: true, characterData: true });
  window.addEventListener('scroll', revisar, { passive: true });
  window.addEventListener('resize', revisar);
  document.addEventListener('click', function () { setTimeout(revisar, 350); });
  copiar(); revisar();
})();

/* Portada foto completa: mide la barra de avisos y la cabecera para que la foto llene la primera pantalla */
(function initPortadaFoto() {
  if (!document.querySelector('[data-ctl-hfoto]')) return;
  function medir() {
    var cab = document.querySelector('.section-header');
    var anuncio = document.querySelector('.announcement-bar-section');
    document.documentElement.style.setProperty('--ctl-cab', (cab ? cab.offsetHeight : 0) + 'px');
    document.documentElement.style.setProperty('--ctl-anuncio', (anuncio ? anuncio.offsetHeight : 0) + 'px');
  }
  medir();
  window.addEventListener('resize', medir);
  window.addEventListener('load', medir);
})();

/* Fotos por color: en la ficha solo se ven las fotos del color elegido y los detalles generales.
   Cada foto lleva su color en el texto alternativo: "Producto — Color" (o "— detalle" si sirve para todos). */
(function initFotosPorColor() {
  document.querySelectorAll('media-gallery').forEach(function (galeria) {
    if (galeria.dataset.ctlColores) return;
    galeria.dataset.ctlColores = '1';
    var info = galeria.closest('product-info') || document;
    function colorDe(li) {
      var img = li.querySelector('img[alt]');
      var alt = img ? img.getAttribute('alt') : '';
      var i = alt.lastIndexOf(' — ');
      return i > -1 ? alt.slice(i + 3).trim().toLowerCase() : '';
    }
    function colorActual() {
      var i = info.querySelector('.ctl-colores input:checked') ||
        info.querySelector('variant-selects input[type="radio"][name^="Color"]:checked, variant-selects input[type="radio"][name^="Colour"]:checked');
      if (i) return i.value.trim().toLowerCase();
      var s = info.querySelector('variant-selects select[name*="Color"], variant-selects select[name*="Colour"]');
      return s ? s.value.trim().toLowerCase() : '';
    }
    function aplicar() {
      var c = colorActual();
      var slides = Array.prototype.slice.call(galeria.querySelectorAll('.product__media-list > li[data-media-id]'));
      var hay = c && slides.some(function (li) { return colorDe(li) === c; });
      var visible = {};
      slides.forEach(function (li) {
        var k = colorDe(li);
        var ver = !hay || !k || k === 'detalle' || k === c;
        visible[li.dataset.mediaId] = ver;
        li.classList.toggle('ctl-oculta', !ver);
      });
      galeria.querySelectorAll('.thumbnail-list > li[data-target]').forEach(function (li) {
        li.classList.toggle('ctl-oculta', visible[li.dataset.target] === false);
      });
      var activa = galeria.querySelector('.product__media-list > li.is-active');
      if (!activa || activa.classList.contains('ctl-oculta')) {
        var primera = galeria.querySelector('.product__media-list > li[data-media-id]:not(.ctl-oculta)');
        if (primera && typeof galeria.setActiveMedia === 'function') galeria.setActiveMedia(primera.dataset.mediaId, false);
      }
      ['[id^="GalleryViewer"]', '[id^="GalleryThumbnails"]'].forEach(function (sel) {
        var s = galeria.querySelector(sel);
        if (s && typeof s.resetPages === 'function' && s.slider) s.resetPages();
      });
      document.dispatchEvent(new CustomEvent('ctl:fotos'));
    }
    var espera;
    function pronto() { clearTimeout(espera); espera = setTimeout(aplicar, 60); }
    info.addEventListener('change', pronto);
    var lista = galeria.querySelector('.product__media-list');
    if (lista) new MutationObserver(pronto).observe(lista, { childList: true });
    aplicar();
  });
})();

/* VENTANA 10% BIENVENIDA: aparece una vez; suscribirse sin recargar y mostrar el código */
(function () {
  if (window.ctlBienvenida) return; window.ctlBienvenida = true;
  var K = 'ctl_bv';
  function leer() { try { return JSON.parse(localStorage.getItem(K) || 'null'); } catch (e) { return null; } }
  function guardar(v) { try { localStorage.setItem(K, JSON.stringify(v)); } catch (e) {} }
  function init(el) {
    if (!el || el.dataset.listo) return; el.dataset.listo = '1';
    if (!(window.Shopify && Shopify.designMode) && el.parentElement !== document.body) document.body.appendChild(el);
    var editor = el.dataset.editor === '1';
    var form = el.querySelector('form'), email = el.querySelector('.ctl-bv__email'), acepto = el.querySelector('[data-ctl-bv-acepto]');
    var err = el.querySelector('[data-ctl-bv-error]'), btn = el.querySelector('.ctl-bv__enviar'), ultimoFoco = null;
    var pasoForm = el.querySelector('[data-ctl-bv-paso="form"]'), pasoOk = el.querySelector('[data-ctl-bv-paso="ok"]');
    var dias = +el.dataset.dias || 14;
    // botón '10% en tu primera compra' (carrito vacío): abre esta ventana aunque se haya cerrado antes; se oculta si ya está suscrito
    function mostrarDiez() { var ok = (leer() || {}).e === 'ok'; document.querySelectorAll('[data-ctl-bv-abrir]').forEach(function (b) { b.hidden = ok; }); }
    var tDiez = null; new MutationObserver(function () { clearTimeout(tDiez); tDiez = setTimeout(mostrarDiez, 120); }).observe(document.body, { childList: true, subtree: true }); mostrarDiez();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ctl-bv-abrir]'); if (!b) return;
      e.preventDefault(); var cd = document.querySelector('cart-drawer'); if (cd && cd.close) cd.close();
      setTimeout(abrir, 250);
    });
    function abrir() {
      if (!el.hidden) return; ultimoFoco = document.activeElement;
      el.hidden = false; document.documentElement.classList.add('ctl-bv-bloqueo');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-abierta'); }); });
      if (!editor) setTimeout(function () { email.focus({ preventScroll: true }); }, 450);
    }
    function cerrar(estado, d) {
      el.classList.remove('is-abierta'); document.documentElement.classList.remove('ctl-bv-bloqueo');
      setTimeout(function () { el.hidden = true; }, 350);
      if (estado && !editor) guardar({ e: estado, hasta: d ? Date.now() + d * 864e5 : 0 });
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
    }
    function exito() { pasoForm.hidden = true; pasoOk.hidden = false; if (!editor) guardar({ e: 'ok', hasta: 0 }); }
    function error(t) { err.textContent = t; err.hidden = false; }
    function revisar() { form.classList.toggle('is-lista', !!(email.value && email.checkValidity() && acepto.checked)); }
    email.addEventListener('input', revisar); acepto.addEventListener('change', revisar);
    el.querySelectorAll('[data-ctl-bv-cerrar]').forEach(function (b) { b.addEventListener('click', function () { cerrar(pasoOk.hidden ? 'cerrado' : 'ok', pasoOk.hidden ? dias : 0); }); });
    var noQ = el.querySelector('[data-ctl-bv-no]'); if (noQ) noQ.addEventListener('change', function () { if (this.checked) setTimeout(function () { cerrar('no', 90); }, 350); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) cerrar(pasoOk.hidden ? 'cerrado' : 'ok', pasoOk.hidden ? dias : 0); });
    el.querySelector('[data-ctl-bv-copiar]').addEventListener('click', function () {
      var b = this, c = el.dataset.codigo;
      var p = navigator.clipboard ? navigator.clipboard.writeText(c) : Promise.resolve();
      p.catch(function () {}).then(function () { b.textContent = b.dataset.copiado; });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      if (!email.value || !email.checkValidity()) { error(el.dataset.errEmail); return; }
      if (!acepto.checked) { error(el.dataset.errAcepto); return; }
      if (editor) { exito(); return; }
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          btn.disabled = false;
          // Shopify puede pedir verificación anti-robots: se envía normal y al volver se muestra el código
          if (/challenge/.test(r.url)) { guardar({ e: 'enviando', hasta: Date.now() + 36e5 }); form.submit(); return; }
          if (r.ok && /customer_posted=true/.test(r.url)) { exito(); return; }
          return r.text().then(function (h) {
            if (r.ok && /customer_posted=true|posted_successfully/.test(h)) exito(); else if (r.ok && !/errors/.test(h)) exito(); else error(el.dataset.errGeneral);
          });
        })
        .catch(function () { btn.disabled = false; error(el.dataset.errGeneral); });
    });
    var st = leer();
    if (st && st.e === 'enviando' && /customer_posted=true/.test(location.search)) { abrir(); exito(); return; }
    if (editor) { abrir(); return; }
    if (/[?&]ctl_bv=1/.test(location.search)) { abrir(); return; }
    if (st && (st.e === 'ok' || (st.hasta && st.hasta > Date.now()))) return;
    var hecho = false;
    function intentar() {
      if (hecho) return;
      if (document.querySelector('cart-drawer.active, .menu-drawer-container[open], header-drawer details[open]')) { setTimeout(intentar, 4000); return; }
      hecho = true; abrir();
    }
    setTimeout(intentar, (+el.dataset.retraso || 6) * 1000);
  }
  function arrancar() { init(document.getElementById('CtlBienvenida')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

/* FICHA (computadora) galería en caja: las fotos se deslizan dentro de un marco del alto de la pantalla (la página no se alarga);
   la miniatura sigue a la foto visible, tocar una miniatura la muestra, línea de progreso */
(function () {
  if (window.ctlGaleriaApilada) return; window.ctlGaleriaApilada = true;
  var mq = window.matchMedia('(min-width: 990px)');
  function init(g) {
    if (!g || g.dataset.ctlApilada || !g.closest('.product--thumbnail_slider')) return; g.dataset.ctlApilada = '1';
    var lista = g.querySelector('.product__media-list'), rail = g.querySelector('.thumbnail-slider'), thumbs = g.querySelector('.thumbnail-list');
    if (!lista || !rail || !thumbs) return;
    function visibles() { return [].slice.call(lista.querySelectorAll('.product__media-item')).filter(function (li) { return li.offsetParent !== null; }); }
    function marcar(id) {
      thumbs.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-current'); });
      var t = thumbs.querySelector('[data-target="' + id + '"]'); if (!t) return;
      var b = t.querySelector('button'); if (b) b.setAttribute('aria-current', 'true');
      var tr = t.getBoundingClientRect(), lr = thumbs.getBoundingClientRect();
      if (tr.top < lr.top || tr.bottom > lr.bottom) thumbs.scrollTo({ top: t.offsetTop - thumbs.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
    }
    var pendiente = false;
    function revisar() {
      pendiente = false; if (!mq.matches) return;
      var items = visibles(); if (!items.length) return;
      var lr = lista.getBoundingClientRect(), centro = lr.top + lista.clientHeight / 2, actual = items[0];
      for (var i = 0; i < items.length; i++) { if (items[i].getBoundingClientRect().top <= centro) actual = items[i]; }
      if (actual.dataset.mediaId) marcar(actual.dataset.mediaId);
      var max = lista.scrollHeight - lista.clientHeight;
      rail.style.setProperty('--ctl-prog', (max > 0 ? Math.min(1, lista.scrollTop / max) : 1).toFixed(3));
    }
    function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); } }
    lista.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    document.addEventListener('ctl:fotos', function () { if (mq.matches) lista.scrollTop = 0; pedir(); });
    function ir(id) {
      var m = lista.querySelector('[data-media-id="' + id + '"]'); if (!m) return;
      lista.scrollTo({ top: m.getBoundingClientRect().top - lista.getBoundingClientRect().top + lista.scrollTop, behavior: 'smooth' });
      marcar(id);
    }
    // tocar una miniatura: deslizar la caja hasta esa foto (sin mover la página)
    thumbs.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var li = e.target.closest('[data-target]'); if (!li) return;
      e.preventDefault(); e.stopImmediatePropagation(); ir(li.dataset.target);
    }, true);
    revisar();
  }
  function arrancar() { document.querySelectorAll('media-gallery').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

/* FAVORITOS: corazón en tarjetas y ficha; se guardan por cuenta (o en el dispositivo si no hay sesión) y se listan en /pages/favoritos */
(function () {
  if (window.ctlFavoritos) return; window.ctlFavoritos = true;
  var cli = window.ctlCliente || 0, K = 'ctl_fav_' + (cli || 'invitado');
  function leer(k) { try { var v = JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function guardar(l) { try { localStorage.setItem(K, JSON.stringify(l)); } catch (e) {} }
  // al iniciar sesión, los favoritos guardados como invitado pasan a la cuenta
  if (cli) {
    var inv = leer('ctl_fav_invitado');
    if (inv.length) { var l0 = leer(K); inv.forEach(function (h) { if (l0.indexOf(h) < 0) l0.push(h); }); guardar(l0); try { localStorage.removeItem('ctl_fav_invitado'); } catch (e) {} }
  }
  function lista() { return leer(K); }
  function pintar() {
    var l = lista();
    document.querySelectorAll('[data-ctl-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-ctl-fav')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? b.getAttribute('data-txt-on') : b.getAttribute('data-txt-off'));
    });
    document.querySelectorAll('[data-ctl-fav-cuenta]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ctl-fav]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-ctl-fav'), l = lista(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else { l.unshift(h); b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 500); }
    guardar(l); pintar();
    if (i > -1) { var li = document.querySelector('[data-ctl-fav-item="' + h + '"]'); if (li) { li.remove(); revisarVacio(); } }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === K) pintar(); });
  // corazones que llegan después (recomendaciones, carrito)
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(pintar, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  // ficha: corazón y "+" fijos sobre la foto (dentro del visor de la galería)
  function acomodar() {
    document.querySelectorAll('[data-ctl-media-acciones]').forEach(function (a) {
      var w = a.closest('.product__media-wrapper'); var v = w && w.querySelector('slider-component[id^="GalleryViewer"]');
      if (v && a.parentElement !== v) { v.classList.add('ctl-con-acciones'); v.appendChild(a); }
    });
  }
  // página de favoritos
  var grid = null, vacio = null;
  function revisarVacio() { if (grid && vacio) vacio.hidden = grid.children.length > 0; }
  function pagina() {
    grid = document.querySelector('[data-ctl-favs-grid]'); vacio = document.querySelector('[data-ctl-favs-vacio]');
    if (!grid || grid.dataset.listo) return; grid.dataset.listo = '1';
    var l = lista(); if (!l.length) { revisarVacio(); return; }
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(l.map(function (h) {
      return fetch(raiz + 'products/' + encodeURIComponent(h) + '?view=ctl-fav').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var vivos = [];
      htmls.forEach(function (html, i) { if (html && html.indexOf('data-ctl-fav-item') > -1) { grid.insertAdjacentHTML('beforeend', html); vivos.push(l[i]); } });
      if (vivos.length !== l.length) guardar(vivos); // productos que ya no existen
      pintar(); revisarVacio();
    });
  }
  function arrancar() { acomodar(); pintar(); pagina(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

/* ---------- RFC o CURP obligatorio antes de pagar (carrito lateral y página del carrito) ---------- */
(function () {
  if (window.ctlRfc) return; window.ctlRfc = true;
  var RFC = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
  var CURP = /^[A-Z][AEIOUX][A-Z]{2}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]\d$/;
  var limpiar = function (v) { return (v || '').toUpperCase().replace(/[\s.\-]/g, ''); };
  var valido = function (v) { return RFC.test(v) || CURP.test(v); };
  var guardado = null, reloj = null;
  function marcar(inp, mal) {
    var caja = inp.closest('[data-ctl-rfc]'); if (!caja) return;
    var ayuda = caja.querySelector('[data-ctl-rfc-ayuda]');
    caja.classList.toggle('is-error', !!mal);
    if (ayuda) ayuda.textContent = mal ? ayuda.dataset.error : ayuda.dataset.ok;
  }
  function guardar(v) {
    if (v === guardado) return; guardado = v;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'RFC o CURP': v } })
    }).catch(function () { guardado = null; });
  }
  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('[data-ctl-rfc-input]'); if (!inp) return;
    var v = limpiar(inp.value); if (inp.value !== v) inp.value = v;
    if (valido(v)) marcar(inp, false);
    clearTimeout(reloj); if (valido(v)) reloj = setTimeout(function () { guardar(v); }, 400);
  });
  document.addEventListener('focusout', function (e) {
    var inp = e.target.closest && e.target.closest('[data-ctl-rfc-input]'); if (!inp) return;
    if (inp.value) marcar(inp, !valido(limpiar(inp.value)));
  });
  document.addEventListener('keydown', function (e) {
    var inp = e.key === 'Enter' && e.target.closest && e.target.closest('[data-ctl-rfc-input]'); if (!inp) return;
    e.preventDefault();
    var btn = document.querySelector('button[name="checkout"][form="' + inp.getAttribute('form') + '"], #' + inp.getAttribute('form') + ' button[name="checkout"]');
    if (btn) btn.click();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]'); if (!btn) return;
    var form = btn.form || btn.closest('form'); if (!form) return;
    var inp = document.querySelector('[data-ctl-rfc-input][form="' + form.id + '"]'); if (!inp) return;
    var v = limpiar(inp.value); inp.value = v;
    if (valido(v)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    marcar(inp, true); inp.focus();
    inp.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
})();
